import { render, staticRenderFns } from "./ModalGenerateLinkLifeProof.vue?vue&type=template&id=589ab8dc"
import script from "./ModalGenerateLinkLifeProof.vue?vue&type=script&lang=js"
export * from "./ModalGenerateLinkLifeProof.vue?vue&type=script&lang=js"
import style0 from "./ModalGenerateLinkLifeProof.vue?vue&type=style&index=0&id=589ab8dc&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('589ab8dc')) {
      api.createRecord('589ab8dc', component.options)
    } else {
      api.reload('589ab8dc', component.options)
    }
    module.hot.accept("./ModalGenerateLinkLifeProof.vue?vue&type=template&id=589ab8dc", function () {
      api.rerender('589ab8dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModalGenerateLinkLifeProof.vue"
export default component.exports